"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles");

var styled_components_1 = require("styled-components");

var greeting_scenario_node_footer_button_container_1 = __importDefault(require("../scenario-node-footer-button-box/greeting-scenario-node-footer-button.container"));

var greeting_scenario_node_styles_1 = require("./greeting-scenario-node.styles");

exports.BodyItemDisplay = function (_ref) {
  var title = _ref.title,
      children = _ref.children;
  return react_1.default.createElement(greeting_scenario_node_styles_1.StyledBodyItemWrapperDiv, null, react_1.default.createElement(greeting_scenario_node_styles_1.StyledBodyItemTitleH2, null, title), react_1.default.createElement(greeting_scenario_node_styles_1.StyledBodyItemContentDiv, null, children));
};

var DAYS = ['日', '月', '火', '水', '木', '金', '土'];

exports.OpeningTimeDisplay = function (_ref2) {
  var openingTimeStr = _ref2.openingTimeStr;
  var openingTimeTitle = "\u672C\u65E5 (".concat(DAYS[new Date().getDay()], "\u66DC\u65E5) \u306E\u53D7\u4ED8\u6642\u9593");
  return react_1.default.createElement(exports.BodyItemDisplay, {
    title: openingTimeTitle
  }, react_1.default.createElement(greeting_scenario_node_styles_1.StyledOpeningTimeP, null, openingTimeStr, react_1.default.createElement(greeting_scenario_node_styles_1.StyledOpeningTimeCommentSpan, null, "\u203B\u6CE8\u91C8")));
};

exports.WaitingTimeDisplay = function (_ref3) {
  var waitingTimeStr = _ref3.waitingTimeStr;
  return react_1.default.createElement(exports.BodyItemDisplay, {
    title: "\u533B\u9662\u306E\u72B6\u6CC1"
  }, react_1.default.createElement(greeting_scenario_node_styles_1.StyledWaitingTimeP, null, waitingTimeStr));
};

exports.TimeTableDisplay = function (_ref4) {
  var timeTable = _ref4.timeTable;
  var rows = timeTable.rows,
      explain = timeTable.explain;
  return react_1.default.createElement(greeting_scenario_node_styles_1.StyledTimeTableDisplayWrapperDiv, null, react_1.default.createElement(greeting_scenario_node_styles_1.StyledTimeTable, {
    "aria-label": "time table"
  }, react_1.default.createElement(greeting_scenario_node_styles_1.StyledTimeTableThead, null, react_1.default.createElement("tr", null, react_1.default.createElement(greeting_scenario_node_styles_1.StyledTimeTableTh, null, "\u8A3A\u7642\u6642\u9593"), DAYS.map(function (day) {
    return react_1.default.createElement(greeting_scenario_node_styles_1.StyledDayTh, {
      key: day
    }, day);
  }))), react_1.default.createElement("tbody", null, Object.keys(rows).map(function (rowKey) {
    var _rows$rowKey = rows[rowKey],
        times = _rows$rowKey.times,
        days = _rows$rowKey.days;

    var _times = _slicedToArray(times, 2),
        openingTime = _times[0],
        closingTime = _times[1];

    return react_1.default.createElement(greeting_scenario_node_styles_1.StyledTimeTableBorderBottomTr, {
      key: rowKey
    }, react_1.default.createElement(greeting_scenario_node_styles_1.StyledTimeTd, null, "".concat(openingTime, "~").concat(closingTime)), days.map(function (status, dayIndex) {
      return react_1.default.createElement(greeting_scenario_node_styles_1.StyledStatusTd, {
        key: dayIndex
      }, status);
    }));
  }))), react_1.default.createElement(greeting_scenario_node_styles_1.StyledExplanationP, null, explain));
};

exports.GreetingScenarioNodeHeaderButton = function (_ref5) {
  var backgroundColor = _ref5.backgroundColor;
  return react_1.default.createElement(greeting_scenario_node_styles_1.StyledBodyButtonDiv, {
    backgroundColor: backgroundColor
  }, "\u76F8\u8AC7\u3092\u958B\u59CB\u3059\u308B");
};

var GreetingScenarioNode = function GreetingScenarioNode(_ref6) {
  var node = _ref6.node,
      _ref6$design = _ref6.design,
      bodyBackColor = _ref6$design.bodyBackColor,
      bodyButtonColor = _ref6$design.bodyButtonColor,
      bodyTextColor = _ref6$design.bodyTextColor,
      footerBackColor = _ref6$design.footerBackColor,
      _ref6$scale = _ref6.scale,
      scale = _ref6$scale === void 0 ? 1 : _ref6$scale;
  var header = node.header,
      waitingTime = node.waitingTime,
      openingTimes = node.openingTimes,
      timeTable = node.timeTable;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: scenario_node_view_styles_1.initNodeTheme(scale)
  }, react_1.default.createElement(greeting_scenario_node_styles_1.StyledGreetingNodeDiv, null, react_1.default.createElement(greeting_scenario_node_styles_1.StyledGreetingNodeHeaderDiv, {
    backgroundColor: bodyBackColor
  }, react_1.default.createElement(greeting_scenario_node_styles_1.StyledGreetingMessagePre, {
    color: bodyTextColor
  }, header), react_1.default.createElement(exports.GreetingScenarioNodeHeaderButton, {
    backgroundColor: bodyButtonColor
  })), react_1.default.createElement(greeting_scenario_node_styles_1.StyledBodyDiv, {
    backgroundColor: footerBackColor
  }, react_1.default.createElement(exports.OpeningTimeDisplay, {
    openingTimeStr: openingTimes[new Date().getDay()]
  }), waitingTime.isEnabled && react_1.default.createElement(exports.WaitingTimeDisplay, {
    waitingTimeStr: waitingTime.status
  }), react_1.default.createElement(exports.TimeTableDisplay, {
    timeTable: timeTable
  }), react_1.default.createElement(greeting_scenario_node_footer_button_container_1.default, null), react_1.default.createElement(greeting_scenario_node_styles_1.StyledReloadP, null, "\u66F4\u65B0\u3059\u308B"))));
};

exports.default = GreetingScenarioNode;